import { Text } from '@atoms/index';
import { opportunitiesGaEventsName } from '@helpers/ga-events-name-enum';
import { triggerCustomGaEvent } from '@helpers/miscelleanous';
import { Modal } from '@ui/atoms';
import Button from '@ui/atoms/design-system/Button';
import { useEffect } from 'react';

const RbiRegulatedSdiNoteModal = ({ show, onClose }) => {
    useEffect(() => 
        triggerCustomGaEvent(opportunitiesGaEventsName.VIEWED_RBI_SDI_POPUP)
    , [])
    return (
        <Modal
            show={show}
            onClose={onClose}
            width="md:w-[400px] sm:w-1/2 max-w-screen-lg"
            height="h-70"
            label={"RBI Regulated SDIs"}
            labelClassName='p3-semibold text-primary-500'
            labelPadding='py-3 px-4'
            paddingClass='pt-3 pb-4 px-4'
            labelSize={' '}
            children={
                <div className=''>
                    <ul className='list-disc text-gray-500 p4-regular pb-5 pl-4'>
                        <li><Text content="Unlisted SDIs are regulated by the Reserve Bank of India." /></li>
                        <li><Text content="Jiraaf being an online bonds platform, is permitted to showcase RBI regulated investment opportunities." /></li>
                        <li><Text content="KYC verification is required for investment in these opportunities and your existing KYC is valid if already verified on Jiraaf." /></li>
                    </ul>
                    <Button buttonSize='medium' buttonText='Understood' onClick={onClose} widthClass={"w-full"} />
                </div>
            }
        />
    )
}

export default RbiRegulatedSdiNoteModal;
